window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.type == 'open' || e.detail.type == 'embedOpen') {
      //gtag('event', 'form_open', {'form': 'Klaviyo form', 'form_id': e.detail.formId});
      Shopify.analytics.publish("klaviyo_form", { 'klav_event' : 'form_open', 'form_id': e.detail.formId});
      // console.log('form open...');
    }
    if (e.detail.type == 'submit') {
      Shopify.analytics.publish("klaviyo_form", { 'klav_event' : 'klaviyo_form_submit'});
      console.log('klaviyo form sent');
    }
    if (e.detail.type == 'stepSubmit') {
       Shopify.analytics.publish("klaviyo_form", { 'klav_event' : 'form_step_submit', 'step_name': e.detail.metaData.$step_name });
      console.log('step');
    }
    if (e.detail.type == 'redirectedToUrl') {
      Shopify.analytics.publish("klaviyo_form", { 'klav_event' : 'redirectedToUrl'});
      console.log('redirectToUrl');
    }
    if (e.detail.type == 'close') {
      Shopify.analytics.publish("klaviyo_form", { 'klav_event' : 'close'});
      // console.log('form closed');
    }
  });


// Listen for URLSearchParams as well
let _sParam = new URLSearchParams(window.location.search);
if(_sParam.get('customer_posted') === 'true') {
   Shopify.analytics.publish("klaviyo_form", { 'klav_event' : 'klaviyo_form_submit'});
   console.log('...klaviyo form sent...');
}